import React, { useMemo, useState, useEffect } from "react";
import { Box, Grid, Modal, Typography } from "@material-ui/core";
import { Chess } from "chess.js";
import { Chessboard, ChessboardDnDProvider, SparePiece } from "react-chessboard";

const modalBoxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '92%',
  maxWidth: '700px',
  bgcolor: '#121212',
  border: '5px solid gold',
  borderRadius: '15px',
  boxShadow: '0 10px 40px rgba(255, 215, 0, 0.4)',
  padding: '25px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  background: 'linear-gradient(145deg, #1a1a1a, #000000)',
};

const GameModeChooserModal = ({ onGameModeUpdate, onClose }) => {
  const [modalOpen, setModalOpen] = useState(true);



  useEffect(() => {

  }, []);

  const handleModeSelect = (mode) => {

    onGameModeUpdate(mode);
    setModalOpen(false);
    onClose && onClose();
  };

  return (
    <Modal
      open={modalOpen}
      onClose={() => {

        setModalOpen(false);
        onClose && onClose();
      }}
    >
      <Box sx={modalBoxStyle}>
        <div style={{
          color: 'gold',
          fontSize: '32px',
          fontWeight: 'bold',
          textAlign: 'center',
          borderBottom: '2px solid gold',
          padding: '20px',
          marginBottom: '25px',
          letterSpacing: '3px'
        }}>
          CHOOSE&nbsp;&nbsp;YOUR&nbsp;&nbsp;GAME&nbsp;&nbsp;MODE
          <br />
          <span style={{
            color: 'white',
            fontSize: '22px',
            fontWeight: 'bold',
            letterSpacing: '1.4px',
            marginTop: '10px',
            display: 'block',
            fontStyle: 'italic'
          }}>
            Categorize Your Content For The Community.
          </span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div style={buttonContainerStyle}>
            <div style={buttonWrapperStyle}>
              <button
                style={{ ...buttonStyle, backgroundColor: '#00f2ea', border: '3px solid #00f2ea', color: 'black', cursor: 'pointer' }}
                onClick={() => handleModeSelect("Puzzle")}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = '0 6px 15px rgba(255, 215, 0, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.4)';
                }}
              >
                Puzzle
              </button>
            </div>
            <div style={contentWrapperStyle}>
              <ul style={bulletListStyle}>
                <li><span style={{ fontWeight: 'bold' }}>One sequence of forcing moves. No variations.</span> </li>
                <li>Typically leads to a forced win or advantage.</li>
              </ul>
            </div>
          </div>

          <div style={buttonContainerStyle}>
            <div style={buttonWrapperStyle}>
              <button
                style={{ ...buttonStyle, backgroundColor: '#3066BE', border: '3px solid #3066be' }}
                onClick={() => handleModeSelect("Lesson")}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = '0 6px 15px rgba(255, 215, 0, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.4)';
                }}
              >
                Lesson
              </button>
            </div>
            <div style={contentWrapperStyle}>
              <ul style={bulletListStyle}>
                <li><span style={{ fontWeight: 'bold' }}>Build unlimited moves & variations.</span> </li>

                <li>Free creative range to teach from this position.</li>
              </ul>
            </div>
          </div>

          {/* <div style={buttonContainerStyle}>
            <div style={buttonWrapperStyle}>
              <button
                style={{ ...buttonStyle, backgroundColor: '#ffca28', color: 'black', border: '3px solid gold' }}
                onClick={() => handleModeSelect("Challenge")}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = '0 6px 15px rgba(255, 215, 0, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.4)';
                }}
              >
                Challenge
              </button>
            </div>
            <div style={contentWrapperStyle}>
              <ul style={bulletListStyle}>
                <li><span style={{ fontWeight: 'bold' }}>Static start position, published without moves.</span> </li>
                <li>Users play the position against the computer.</li>
                <li>Tip: Use famous positions, or create your own.</li>
              </ul>
            </div>
          </div> */}
        </div>

        <button
          style={{
            ...cancelButtonStyle,
            transition: 'all 0.3s ease',
            backgroundColor: '#ff0000',
          }}
          onClick={() => {
            setModalOpen(false);
            onClose && onClose();
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-3px)';
            e.currentTarget.style.boxShadow = '0 6px 15px rgba(0, 0, 0, 0.3)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.2)';
          }}
        >
          CANCEL
        </button>
      </Box>
    </Modal>
  );
};

const buttonContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  padding: '5px',
  borderRadius: '10px',
  color: 'white',
  transition: 'all 0.3s ease',
  height: '100px',
};

const buttonWrapperStyle = {
  minWidth: '230px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const contentWrapperStyle = {
  flex: '1',
  display: 'flex',
  alignItems: 'center',
};

const buttonStyle = {
  padding: '15px 20px',
  width: '220px',
  height: '100px',
  fontSize: '24px',
  fontWeight: 'bold',
  borderRadius: '8px',
  cursor: 'pointer',
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.4)',
  letterSpacing: '1px',
  color: 'black',
  transition: 'all 0.3s ease',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const cancelButtonStyle = {
  ...buttonStyle,
  alignSelf: 'center',
  marginTop: '15px',
  backgroundColor: '#ff5252',
  color: 'white',
  border: '3px solid #222',
  letterSpacing: '3px',
  fontSize: '20px',
  fontWeight: 'bold',
  width: '200px',
  height: '60px',
};

const bulletListStyle = {
  listStyleType: 'disc',
  paddingLeft: '20px',
  margin: 0,
  fontSize: '17px',
  lineHeight: '2',
};

export default GameModeChooserModal;